import { Box, IconButton, Grid, Tooltip } from '@mui/material';
import MaterialTable from 'material-table';
import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import EditIcon from '@mui/icons-material/Edit';
// import DeleteIcon from '@mui/icons-material/Delete';
// import AddIcon from '@mui/icons-material/Add';
import Popup from "../../../../Base/views/Popup"
import { useState } from 'react';
// import ConfirmationDialog from '../../../../Base/views/ConfirmationDialog';
import {
    //  DeletePHAllowanceAction, 
     GetPHAllowanceAction } from '../../../../../../store/Finance/PayRollTemplate/Action';
import PHAllowance from './PHAllowance';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

const PHAllowanceGrid = () => {
    const dispatch = useDispatch();
    const { ph_allowance_data, isLoadingPHAllowance } = useSelector(state => state.FinanceReducer?.PayrollTemplateReducer);
    const [editedRecord, setEditedRecord] = useState(null);
    const [openPopup, setOpenPopup] = useState(false);
    // const [openDialog, setOpenDialog] = useState(false);
    // const [currentData, setCurrentData] = useState({});
  useEffect(() => {
            dispatch(GetPHAllowanceAction());
          // eslint-disable-next-line react-hooks/exhaustive-deps
      }, [])
    const handleEdit = (rowData) => {
        setEditedRecord(rowData);
        setOpenPopup(true);
    };

    // const handleConfirmDelete = (rowData) => {
    //     setOpenDialog(true);
    //     setCurrentData(rowData)
    // };

    // const handleAdd = () => {
    //     setEditedRecord()
    //     setOpenPopup(true);
    // };

    // const handleDelete = () => {
    //     setOpenDialog(false);
    //     dispatch(DeletePHAllowanceAction({ ph_allowance_configuration_pk: currentData?.ph_allowance_configuration_pk }))
    // };

    const addMode = (resetForm) => {
        resetForm();
        setEditedRecord(null);
        setOpenPopup(false);
    };

    // const addButton = ph_allowance_data?.length < 1 && (<Button onClick={handleAdd} variant="contained" className="mpl-primary-btn" startIcon={<AddIcon />} >
    //     Add
    // </Button>);
    return (
        <Grid container spacing={2} style={{ padding: "10px 0px" }}>
            <Grid item xs={12} md={12}>
                <Box>
                    <MaterialTable
                        isLoading={isLoadingPHAllowance}
                        columns={[
                             { 
                                title: "Allowance Type", 
                                field: "ph_allowance_type", 
                                cellStyle: { padding: "10px 10px 10px 13px" } 
                            },
                            { 
                                 title: (
                                    <span>
                                        Flat Amount / Day&nbsp;
                                        <Tooltip title="A flat amount paid per PH day worked. Half-day work earns 50% of the fixed amount." placement="top" arrow>
                                            <InfoOutlinedIcon fontSize="small" color="action" style={{ verticalAlign: "middle", cursor: "pointer" }} />
                                        </Tooltip>
                                    </span>
                                ), 
                                field: "flat_amount", 
                                cellStyle: { padding: "10px 10px 10px 13px" },
                                hidden: ph_allowance_data?.[0]?.ph_allowance_type === "Variable"
                            },
                            { 
                                title: (
                                    <span>
                                        Earning Components&nbsp;
                                        <Tooltip title="Calculated using selected earning components. Pro-rated based on PH days worked during the pay period." placement="top" arrow>
                                            <InfoOutlinedIcon fontSize="small" color="action" style={{ verticalAlign: "middle", cursor: "pointer" }} />
                                        </Tooltip>
                                    </span>
                                ),
                                field: "ph_allowance_earning_components", 
                                cellStyle: { padding: "10px 10px 10px 13px" },
                                 render: rowData => {
                                    try {
                                        const arr = typeof rowData?.ph_allowance_earning_components === "string"
                                            ? JSON.parse(rowData.ph_allowance_earning_components)
                                            : rowData.ph_allowance_earning_components;
                                        return Array.isArray(arr)
                                            ? arr?.map(item => item.label).join(", ")
                                            : "";
                                    } catch {
                                        return "";
                                    }
                                },
                                hidden: ph_allowance_data?.[0]?.ph_allowance_type === "Flat"
                            },
                            { 
                                title: (
                                    <span>
                                        PH Rate&nbsp;
                                        <Tooltip title={ ph_allowance_data?.[0]?.ph_rate ? "Applies a multiplier to selected earning components for public holiday work (e.g. a rate of 2 means 2× the total of those components)." : "Applies a multiplier to flat amount for public holiday work. (e.g. a rate of 2 means 2× flat amout.)" } placement="top" arrow>
                                            <InfoOutlinedIcon fontSize="small" color="action" style={{ verticalAlign: "middle", cursor: "pointer" }} />
                                        </Tooltip>
                                    </span>
                                ),
                                field: "ph_rate", 
                                cellStyle: { padding: "10px 10px 10px 13px" },
                                render: rowData => rowData.ph_rate  ?  rowData.ph_rate : 1
                            },
                        ]}
                        data={ph_allowance_data}
                        options={{
                            maxBodyHeight: 220,
                            rowStyle: { fontSize: "13px" },
                            headerStyle: { padding: "5px 30px 5px 10px", fontWeight: "bold" },
                            sorting: false,
                            search: false,
                            searchFieldAlignment: "right",
                            searchAutoFocus: true,
                            searchFieldVariant: "standard",
                            filtering: false,
                            paging: false,
                            selection: false,
                            actionsColumnIndex: -1,
                            grouping: false,
                            addRowPosition: "first",
                        }}
                        onSelectionChange={(rows) => { return (rows.filter(row => row?.status === "Submitted")) }}
                        actions={[
                            {
                                icon: () => <IconButton sx={{ padding: "0px" }}><EditIcon /></IconButton>,
                                tooltip: "Edit",
                                onClick: (_event, rowData) => { handleEdit(rowData) },
                            },
                            // {
                            //     icon: () => <IconButton sx={{ padding: "0px" }}><DeleteIcon /></IconButton>,
                            //     tooltip: "Delete",
                            //     onClick: (_event, rowData) => { handleConfirmDelete(rowData) },
                            // },
                        ]}
                        title=""
                        components={{
                            Toolbar: props => (
                                <div style={{
                                    minHeight: "10px",
                                    padding: "10px 25px",
                                    borderRadius:"5px 5px 0px 0px"
                                }}>
                                    {props.title}
                                </div>
                            )
                        }}
                    />
                    <Popup
                        fullWidth={true}
                        maxWidth="sm"
                        title={editedRecord ? "Edit" : "Add"}
                        openPopup={openPopup}
                        setOpenPopup={setOpenPopup}

                    >
                        <PHAllowance editedRecord={editedRecord} addMode={addMode} setOpenPopup={setOpenPopup} />
                    </Popup>
                    {/* <ConfirmationDialog
                        title="Do you wish to proceed?"
                        openDialog={openDialog}
                        closeDialog={setOpenDialog}
                        popupTitle="Country Management"
                        OkButtonText="Delete"
                        onSubmit={handleDelete}
                    /> */}
                </Box>
            </Grid>
        </Grid>
    );
}

export default PHAllowanceGrid;
